export const COLOR = {
    white: 'rgb(200,200,200)',
    black: 'rgb(0,0,0)',
    red: 'rgb(91,8,8)',
};